module.exports = __webpack_public_path__ + "img/left-m-me.ecf95e3.webp";